import { Folder } from '@/api/generatedApi';
import { DeleteFolderModal } from '@/components/modals/DeleteFolderModal';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useState } from 'react';

export const DeleteFolderButton = ({
  folder,
  size = 'small',
  onDelete,
}: {
  folder: Folder;
  size?: IconButtonProps['size'];
  onDelete?: () => void;
}) => {
  const { permissions } = useGetCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!permissions.canDeleteFolders) {
    return;
  }

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Tooltip title='Delete folder'>
        <IconButton onClick={handleClick} size={size} color='error'>
          <DeleteIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      </Tooltip>
      <DeleteFolderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        folder={folder}
        onDelete={() => {
          setIsModalOpen(false);
          onDelete?.();
        }}
      />
    </>
  );
};
